/**
 * Utility to merge multiple refs into one
 * Handles both function refs and ref objects
 */
export function mergeRefs<T>(...refs: Array<React.Ref<T> | undefined>): React.RefCallback<T> {
  return (element: T) => {
    for (const ref of refs) {
      if (!ref) continue;

      if (typeof ref === "function") {
        ref(element);
      } else if (ref && "current" in ref) {
        (ref as React.MutableRefObject<T | null>).current = element;
      }
    }
  };
}
